import { useEffect, useState } from "react";
import { Wind } from "lucide-react";

// A gentle breathing guide: slow expand (inhale) / longer contract (exhale).
export default function BreathGuide() {
  const [active, setActive] = useState(false);
  const [phase, setPhase] = useState("in"); // "in" | "out"

  useEffect(() => {
    if (!active) return;
    let t;
    const cycle = (p) => {
      setPhase(p);
      t = setTimeout(() => cycle(p === "in" ? "out" : "in"), p === "in" ? 4000 : 6000);
    };
    cycle("in");
    return () => clearTimeout(t);
  }, [active]);

  const scale = active ? (phase === "in" ? 1 : 0.55) : 0.72;
  const duration = phase === "in" ? "4s" : "6s";

  return (
    <section data-testid="breath-guide" className="max-w-7xl mx-auto px-6 py-16">
      <div className="glass rounded-3xl px-6 py-14 flex flex-col items-center text-center">
        <p className="flex items-center gap-2 text-xs uppercase tracking-[0.3em] text-[#D4AF37] mb-3">
          <Wind size={14} /> Breath Guide
        </p>
        <h2 className="serif text-3xl sm:text-4xl text-[#F5F1E7] font-light">
          Before you begin, <span className="italic-serif text-[#D4AF37]">arrive.</span>
        </h2>
        <p className="mt-3 text-[#B4A897] max-w-md leading-relaxed">
          Let the noise of the day settle. Follow the circle for a few breaths and let peace
          find you before you write.
        </p>

        <div className="relative mt-12 h-56 w-56 grid place-items-center">
          <span
            className="absolute rounded-full"
            aria-hidden
            style={{
              height: "14rem",
              width: "14rem",
              transform: `scale(${scale})`,
              transition: `transform ${duration} ease-in-out`,
              background:
                "radial-gradient(circle, rgba(212,175,55,0.28), rgba(212,175,55,0.06) 60%, transparent 72%)",
              boxShadow: "0 0 60px rgba(212,175,55,0.18)",
            }}
          />
          <span
            className="absolute rounded-full border border-[#D4AF37]/40"
            aria-hidden
            style={{
              height: "9rem",
              width: "9rem",
              transform: `scale(${scale})`,
              transition: `transform ${duration} ease-in-out`,
            }}
          />
          <span
            data-testid="breath-label"
            className="relative serif text-2xl text-[#F7F1E6] transition-opacity duration-700"
          >
            {active ? (phase === "in" ? "Breathe in" : "Breathe out") : "Be still"}
          </span>
        </div>

        <button
          data-testid="breath-toggle"
          onClick={() => setActive((v) => !v)}
          className="mt-12 inline-flex items-center gap-2 rounded-full border border-[#D4AF37]/50 text-[#D4AF37] px-7 py-2.5 text-sm hover:bg-[#D4AF37]/10 transition-colors duration-300"
        >
          {active ? "Rest here" : "Begin breathing"}
        </button>
      </div>
    </section>
  );
}
